import { ReactNode } from 'react';
import { Container } from '@/components/ui/layout';
import { Card } from '@/components/ui/data-display';
import { ScaleIn, HoverLift } from '@/components/animations';

export interface AuthCardProps {
  children: ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md';
}

export function AuthCard({ children, maxWidth = 'xs' }: AuthCardProps) {
  return (
    <Container size={maxWidth} w="100%">
      <ScaleIn delay={100} duration={500}>
        <HoverLift>
          <Card variant="elevated" p="xl" radius="lg">
            {children}
          </Card>
        </HoverLift>
      </ScaleIn>
    </Container>
  );
}

export default AuthCard;
